import { render, staticRenderFns } from "./clickSwitch.vue?vue&type=template&id=1cf6e745&scoped=true"
import script from "./clickSwitch.vue?vue&type=script&lang=js"
export * from "./clickSwitch.vue?vue&type=script&lang=js"
import style0 from "./clickSwitch.vue?vue&type=style&index=0&id=1cf6e745&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf6e745",
  null
  
)

export default component.exports